module.exports = __webpack_public_path__ + "img/menu_safe_pre.3958416b.svg";